
import { Vue } from "vue-class-component";

export default class AutoCopy extends Vue {}
